import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_quote_list = _resolveComponent("quote-list")!
  const _component_tab = _resolveComponent("tab")!
  const _component_tabs = _resolveComponent("tabs")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[4] || (_cache[4] = _createElementVNode("div", null, [
      _createElementVNode("h1", null, "Manage Quote Requests"),
      _createElementVNode("p", null, "View and respond to quote requests")
    ], -1)),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_tabs, {
            options: { useUrlFragment: false, defaultTabHash: 'to-do' },
            "nav-class": "nav nav-pills m-3",
            "nav-item-class": "nav-item col-md-3 col-sm-12 text-center",
            "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
            "nav-item-link-active-class": "active"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_tab, {
                prefix: "<h2 class='mt-2'>",
                suffix: "</h2>",
                name: "To Do",
                id: "quotes-to-do"
              }, {
                default: _withCtx(() => [
                  _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                  _createVNode(_component_quote_list, {
                    quotes: _ctx.todo,
                    type: "todo"
                  }, null, 8, ["quotes"])
                ]),
                _: 1
              }),
              _createVNode(_component_tab, {
                prefix: "<h2 class='mt-2'>",
                suffix: "</h2>",
                name: "Pending",
                id: "quotes-pending"
              }, {
                default: _withCtx(() => [
                  _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                  _createVNode(_component_quote_list, {
                    quotes: _ctx.pending,
                    type: "pending"
                  }, null, 8, ["quotes"])
                ]),
                _: 1
              }),
              _createVNode(_component_tab, {
                prefix: "<h2 class='mt-2'>",
                suffix: "</h2>",
                name: "Completed",
                id: "quotes-completed"
              }, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                  _createVNode(_component_quote_list, {
                    quotes: _ctx.completed,
                    type: "completed"
                  }, null, 8, ["quotes"])
                ]),
                _: 1
              }),
              _createVNode(_component_tab, {
                prefix: "<h2 class='mt-2'>",
                suffix: "</h2>",
                name: "Rejected",
                id: "quotes-rejected"
              }, {
                default: _withCtx(() => [
                  _cache[3] || (_cache[3] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
                  _createVNode(_component_quote_list, {
                    quotes: _ctx.rejected,
                    type: "rejected"
                  }, null, 8, ["quotes"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}